
import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./Na2HydroGen.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PumpContext } from "../context/PumpContext";

import { trackPageVisit } from "../competency/PageTracker";

 

 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function Na2HydroGen() {

        useEffect(() => {
  
    trackPageVisit("Na2HydroGen");
  
  }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);

     const { pumpData } = useContext(PumpContext);
   

  


  const DEFAULT_VALVES = {
  FCV_2961: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2962: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2963: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("Na2HydroGen_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2961: { ...DEFAULT_VALVES.FCV_FCV_2961, ...parsed.FCV_2961 },
      FCV_2962: { ...DEFAULT_VALVES.FCV_FCV_2962, ...parsed.FCV_2962 },
      FCV_2963: { ...DEFAULT_VALVES.FCV_FCV_2963, ...parsed.FCV_2963 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("Na2HydroGen_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};






// ================= PDT_2961 (FOULING FACTOR - SEAWATER STRAINER) =================
const [PDT_2961, setPDT_2961] = useState(() => {
  return Number(localStorage.getItem("PDT_2961")) || 0; // default = clean filter
});

// ================= SAVE =================
useEffect(() => {
  localStorage.setItem("PDT_2961", PDT_2961);
}, [PDT_2961]);

const [pdt2961Position, setPdt2941Position] = useState({ x: 320, y: 370 }); // 🔧 adjust freely



// ================= TDS_2961 (FOULING FACTOR - SEAWATER STRAINER) =================
const [TDS_2961, setTDS_2961] = useState(() => {
  return Number(localStorage.getItem("TDS_2961")) || 0; // default = clean filter
});

// ================= SAVE =================
useEffect(() => {
  localStorage.setItem("TDS_2961", TDS_2961);
}, [TDS_2961]);

const [tds2961Position, setTds2961Position] = useState({ x: 445, y: 440 }); // 🔧 adjust freely


// ================= SCT_2962 (FOULING FACTOR - SEAWATER STRAINER) =================
const [SCT_2962, setSCT_2962] = useState(() => {
  return Number(localStorage.getItem("SCT_2962")) || 0; // default = clean filter
});

// ================= SAVE =================
useEffect(() => {
  localStorage.setItem("SCT_2962", SCT_2962);
}, [SCT_2962]);

const [sct2962Position, setSct2962Position] = useState({ x: 445, y: 400 }); // 🔧 adjust freely









// ================= RETREIVING STORED TRANSMITTERS FROM LOCAL STORAGE IN OTHER PAGES =================

  const [FIC_2945, setFIC_2945] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2945")) || 0;
            setFIC_2945(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_2946, setPT_2946] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_2946")) || 0;
            setPT_2946(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);







// ================= VALVE AND PUMPS INITIALIZATION AND STATUS =================
  const isXV2961Open = valves?.XV_2961 === false;
  const isXV2962Open = valves?.XV_2962 === false;
  const isXV2963Open = valves?.XV_2963 === false;

  const isP2961On = pumpData?.["P-2961"]?.running ?? false;
  const isP2962On = pumpData?.["P-2962"]?.running ?? false;
  const isP2963On = pumpData?.["P-2963"]?.running ?? false;




  const FIC_2965 = FIC_2945*0.989;
  const FIC_2965a = isXV2963Open ? FIC_2965 : 0;
  const FIC_2965b = isXV2961Open ? 20 : 0;
  const FIC_2965c = 4;

  const PT_2965 = PT_2946*0.989;

  const SCT_2961 = 30;

      
    const opening2962 = (valveData?.FCV_2962?.opening || 0) / 100;
    const opening2963 = (valveData?.FCV_2963?.opening || 0) / 100;

    let SCT_2963 = 0;

    // ================= PRIORITY LOGIC =================

    // 🔴 BOTH PUMPS RUNNING
    if (isP2961On && isP2962On) {

      SCT_2963 = SCT_2961 * ((SCT_2962 / 20) * opening2963);

    }

    // 🟢 ONLY P-2961 RUNNING
    else if (isP2961On) {

      SCT_2963 = SCT_2961 * opening2962;

    }

    // 🔵 ONLY P-2962 RUNNING
    else if (isP2962On) {

      SCT_2963 = SCT_2962 * opening2963;

    }












  // ================= LIMITS =================
  const MIN_TEMP = 28;
  const MAX_TEMP = 50;

  // ================= STATE =================
  const [isCoilOn, setIsCoilOn] = useState(false);

  const [TT_2962, setTT_2962] = useState(() => {
    return Number(localStorage.getItem("TT_2962")) || MIN_TEMP;
  });

  // 🔹 Position state (X, Y)
  const [position, setPosition] = useState(() => {
    const saved = localStorage.getItem("coil_position");
    return saved ? JSON.parse(saved) : { x: 100, y: 100 };
  });

  // 🔹 Dragging state
  const [isDragging, setIsDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  // ================= TARGET =================
  const targetTemp = isCoilOn ? MAX_TEMP : MIN_TEMP;

  // ================= TEMPERATURE DYNAMICS =================
  useEffect(() => {

    const interval = setInterval(() => {
      setTT_2962(prev => {
        const next = prev + (targetTemp - prev) * 0.04;
        return Number(next.toFixed(2));
      });
    }, 100);

    return () => clearInterval(interval);

  }, [targetTemp]);

  // ================= SAVE =================
  useEffect(() => {
    localStorage.setItem("TT_2962", TT_2962);
  }, [TT_2962]);

  useEffect(() => {
    localStorage.setItem("coil_position", JSON.stringify(position));
  }, [position]);

  // ================= COLOR LOGIC =================
  const getColor = () => {
    const ratio = (TT_2962 - MIN_TEMP) / (MAX_TEMP - MIN_TEMP);

    const red = 255;
    const green = Math.floor(255 - 200 * ratio);
    const blue = Math.floor(255 - 200 * ratio);

    return `rgb(${red}, ${green}, ${blue})`;
  };

  // ================= TOGGLE =================
  const handleToggle = () => {
    // Prevent toggle when dragging
    if (!isDragging) {
      setIsCoilOn(prev => !prev);
    }
  };

  // ================= DRAG HANDLERS =================
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y
    });
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;

    setPosition({
      x: e.clientX - offset.x,
      y: e.clientY - offset.y
    });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // Attach global listeners
  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  });

  







  
  // ================= WATER SOFTENER PUMPS =================

const runningPumps2961 = [isP2961On].filter(Boolean).length;

// ================= SUCTION INPUTS =================
const suctionFlow2964 = 0;
const suctionPressure2961 = 0;

// ================= DESIGN LIMITS =================
const MAX_DISCH_PRESSURE_2961 = 1.3 * (1 - ((10/100) * (valveData?.FCV_2962?.opening || 0)/100));
const MIN_DISCH_PRESSURE_2961 = 0.5;

// ================= TARGET CALCULATIONS =================
let targetPT_2961 = MIN_DISCH_PRESSURE_2961;
let targetFIC_2964 = 0;

if (runningPumps2961 > 0) {

  // 🔹 Flow boost
  targetFIC_2964 =  50 * (valveData?.FCV_2962?.opening || 0)/100;

  // 🔹 Pressure rises to design max
  targetPT_2961 = MAX_DISCH_PRESSURE_2961;

}

// ================= STATES =================
const [PT_2961, setPT_2961] = useState(() => {
  return Number(localStorage.getItem("PT_2961")) || 0.03;
});

const [FIC_2964, setFIC_2964] = useState(() => {
  return Number(localStorage.getItem("FIC_2964")) || 0;
});

// ================= SMOOTHING (DCS RESPONSE) =================
useEffect(() => {

  const interval = setInterval(() => {

    // 🔹 PRESSURE RESPONSE
    setPT_2961(prev => {
      const next = prev + (targetPT_2961 - prev) * 0.15;
      return Number(next.toFixed(3));
    });

    // 🔹 FLOW RESPONSE
    setFIC_2964(prev => {
      const next = prev + (targetFIC_2964 - prev) * 0.12;
      return Number(next.toFixed(2));
    });

  }, 100); // 🔥 fast response like DCS

  return () => clearInterval(interval);

}, [targetPT_2961, targetFIC_2964]);

// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("PT_2961", PT_2961);
}, [PT_2961]);

useEffect(() => {
  localStorage.setItem("FIC_2964", FIC_2964);
}, [FIC_2964]);







 
  // ================= DISSOLVED SODIUM CHLORIDE PUMPS =================
const runningPumps2962 = [isP2962On].filter(Boolean).length;

// ================= SUCTION INPUTS =================
const suctionFlow2962 = 0;
const suctionPressure2962 = 0;

// ================= DESIGN LIMITS =================
const MAX_DISCH_PRESSURE_2962 = 1.3 * (1 - ((10/100) * (valveData?.FCV_2963?.opening || 0)/100));
const MIN_DISCH_PRESSURE_2962 = 0.5;

// ================= TARGET CALCULATIONS =================
let targetPT_2962 = MIN_DISCH_PRESSURE_2962;
let targetFIC_2962 = 0;

if (runningPumps2962 > 0) {

  // 🔹 Flow boost
  targetFIC_2962 =  50 * (valveData?.FCV_2963?.opening || 0)/100;

  // 🔹 Pressure rises to design max
  targetPT_2962 = MAX_DISCH_PRESSURE_2962;

}

// ================= STATES =================
const [PT_2962, setPT_2962] = useState(() => {
  return Number(localStorage.getItem("PT_2962")) || 0.03;
});

const [FIC_2962, setFIC_2962] = useState(() => {
  return Number(localStorage.getItem("FIC_2962")) || 0;
});

// ================= SMOOTHING (DCS RESPONSE) =================
useEffect(() => {

  const interval = setInterval(() => {

    // 🔹 PRESSURE RESPONSE
    setPT_2962(prev => {
      const next = prev + (targetPT_2962 - prev) * 0.15;
      return Number(next.toFixed(3));
    });

    // 🔹 FLOW RESPONSE
    setFIC_2962(prev => {
      const next = prev + (targetFIC_2962 - prev) * 0.12;
      return Number(next.toFixed(2));
    });

  }, 100); // 🔥 fast response like DCS

  return () => clearInterval(interval);

}, [targetPT_2962, targetFIC_2962]);

// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("PT_2962", PT_2962);
}, [PT_2962]);

useEffect(() => {
  localStorage.setItem("FIC_2962", FIC_2962);
}, [FIC_2962]);




const FIC_2961 = FIC_2964 + FIC_2962;

const TT_2961 = TT_2962 *0.95;













  // ================= WATER SOFTENER PUMPS =================

const runningPumps2963 = [isP2963On].filter(Boolean).length;

// ================= SUCTION INPUTS =================
const suctionFlow2963 = 0;
const suctionPressure2963 = 0;

// ================= DESIGN LIMITS =================
const MAX_DISCH_PRESSURE_2963 = isXV2962Open ? 1.3 * (1 - ((10/100) * (valveData?.FCV_2961?.opening || 0)/100)) : 0.03;
const MIN_DISCH_PRESSURE_2963 = 0.5;

// ================= TARGET CALCULATIONS =================
let targetPT_2963 = MIN_DISCH_PRESSURE_2963;
let targetFIC_2963 = 0;

if (runningPumps2963 > 0) {

  // 🔹 Flow boost
  targetFIC_2963 = isXV2962Open ? 50 * (valveData?.FCV_2961?.opening || 0)/100 : 0;

  // 🔹 Pressure rises to design max
  targetPT_2963 = MAX_DISCH_PRESSURE_2963;

}

// ================= STATES =================
const [PT_2963, setPT_2963] = useState(() => {
  return Number(localStorage.getItem("PT_2963")) || 0.03;
});

const [FIC_2963, setFIC_2963] = useState(() => {
  return Number(localStorage.getItem("FIC_2963")) || 0;
});

// ================= SMOOTHING (DCS RESPONSE) =================
useEffect(() => {

  const interval = setInterval(() => {

    // 🔹 PRESSURE RESPONSE
    setPT_2963(prev => {
      const next = prev + (targetPT_2963 - prev) * 0.15;
      return Number(next.toFixed(3));
    });

    // 🔹 FLOW RESPONSE
    setFIC_2963(prev => {
      const next = prev + (targetFIC_2963 - prev) * 0.12;
      return Number(next.toFixed(2));
    });

  }, 100); // 🔥 fast response like DCS

  return () => clearInterval(interval);

}, [targetPT_2963, targetFIC_2963]);

// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("PT_2963", PT_2963);
}, [PT_2963]);

useEffect(() => {
  localStorage.setItem("FIC_2963", FIC_2963);
}, [FIC_2963]);







const pH_2961 =  7 + (TT_2962/11);
const CLT_2961 =  isCoilOn ? 0.2 + (TT_2962/64) : 0;



     


  return (
    <div className="Na2HydroGen-container"> 
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "248px",
        color: "white",
        background: "rgba(39, 18, 233, 0.5)", 
        padding: "2px 180px"
      }}>
        NADIUM HYPOCHLORITE GENERATOR
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2931 */}
      <Valve
        className="XV-2961"
        tag="XV_2961"
        x={390}
        y={124}
        isClosed={valves.XV_2961}
        toggle={toggleValve}
      />

      {/* XV-2962 */}
      <Valve
        className="XV-2962"
        tag="XV_2962"
        x={766}
        y={617}
        isClosed={valves.XV_2962}
        toggle={toggleValve}
      />
      {/* XV-2963 */}
      <Valve
        className="XV-2963"
        tag="XV_2963"
        x={155}
        y={162}
        isClosed={valves.XV_2963}
        toggle={toggleValve}
      />

      
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2961 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2961"
          style={{ position: "absolute", left: 542, top: 610}}  onClick={() => openPanel("FCV_2961")}>
          
          <defs>
            <linearGradient id="metal_2961">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2961)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2961)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>



        {/* FCV-2962 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2962"
          style={{ position: "absolute", left: 706, top: 247, transform: "rotate(90deg)", transformOrigin: "center" }}  onClick={() => openPanel("FCV_2962")}>
          
          <defs>
            <linearGradient id="metal_2962">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2962)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2962)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>

          

        {/* FCV-2963 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2963"
          style={{ position: "absolute", left: 706, top: 447, transform: "rotate(90deg)", transformOrigin: "center" }}  onClick={() => openPanel("FCV_2963")}>
          
          <defs>
            <linearGradient id="metal_2963">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2963)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2963)" stroke="#7f8c8d" strokeWidth="2" />

          </svg>

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

          
          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_2961?.opening || 0)}
        x={567}
        y={654}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2962?.opening || 0)}
        x={765}
        y={292}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2963?.opening || 0)}
        x={765}
        y={501}
      />





      {/* ================= TRANSMITTERS OUTPUTS ================= */}
      
        <Transmitter
          tag="FIC-2965"
          value={[FIC_2965]}
          x={114}
          y={112}
          unit="LPM"
          max={300}
          HH={250}
          H={200}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF SEAWATER FROM DISCHARGE OF SEAWATER STRAINERS AT SEAWATER TREATMENT PAGE TO HYPOCHLORITE GENERATOR WATER SOFTENER TANKS"
        />

         <Transmitter
          tag="PT-2965"
          value={PT_2965}
          x={188}
          y={112}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF SEAWATER FROM DISCHARGE OF SEAWATER STRAINERS AT SEAWATER TREATMENT PAGE TO HYPOCHLORITE GENERATOR WATER SOFTENER TANKS"
        />
         
         <Transmitter
          tag="SCT-2961"
          value={SCT_2961}
          x={539}
          y={282}
          unit="%"
          max={40}
          HH={39}
          H={37}
          L={31}
          LL={30}
          c="lime"
          description="SEAWATER SALT CONCENTRATION TRANSMITTER AFTER SOFTENER"
        />
         <Transmitter
          tag="SCT-2963"
          value={SCT_2963}
          x={739}
          y={226}
          unit="%"
          max={40}
          HH={39}
          H={37}
          L={31}
          LL={30}
          c="lime"
          description="SEAWATER SALT CONCENTRATION TRANSMITTER AFTER SOFTENER"
        />

        <Transmitter
          tag="FIC-2964"
          value={[FIC_2964]}
          x={639}
          y={328}
          unit="LPM"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF SOFT SEAWATER FROM DISCHARGE OF WATER PUMP"
        />

         <Transmitter
          tag="PT-2961"
          value={PT_2961}
          x={639}
          y={276}
          unit="MPa"
          max={2}
          HH={1.7}
          H={1.4}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF SOFT SEAWATER FROM DISCHARGE OF WATER PUMP"
        />
        <Transmitter
          tag="FIC-2962"
          value={[FIC_2962]}
          x={539}
          y={510}
          unit="LPM"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF DISSOLVED SODIUM CHLORIDE FROM SALT WATER PUMP TO ELECTROLYTE COIL"
        />

         <Transmitter
          tag="PT-2962"
          value={PT_2962}
          x={625}
          y={510}
          unit="MPa"
          max={2}
          HH={1.7}
          H={1.4}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF DISSOLVED SODIUM CHLORIDE FROM SALT WATER PUMP TO ELECTROLYTE COIL"
        />


        <Transmitter
          tag="FIC-2961"
          value={[FIC_2961]}
          x={739}
          y={148}
          unit="LPM"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF MIXTURE SOFT WATER AND DISSOLVED SODIUM CHLORIDE TO ELECTROLYTE COIL"
        />
        <Transmitter
          tag="FIC-2963"
          value={[FIC_2963]}
          x={209}
          y={668}
          unit="LPM"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF SODIUM HYPOCHLORITE LIQUID OUT OF SODIUM HYPOCHLORITE TANK TO SEAWATER BED FOR DISINFECTANT"
        />

        <Transmitter
          tag="PT-2963"
          value={PT_2963}
          x={287}
          y={668}
          unit="MPa"
          max={2}
          HH={1.7}
          H={1.4}
          L={0.04}
          LL={0.01}
          c="lime"
          description="PRESSURE OF SODIUM HYPOCHLORITE LIQUID OUT OF SODIUM HYPOCHLORITE TANK TO SEAWATER BED FOR DISINFECTANT"
        />








    <LevelTransmitterIndicator
      tag="LT_2961"
      totalLevel={50000}
      inflows={[FIC_2965a]}
      outflows={[FIC_2965b]}
      responseFactor={0.05}
      columnX={278}
      columnY={178}
      columnWidth={28}
      columnHeight={110}
      textX={175}
      textY={220}
      showFlow={true}
    />
    <LevelTransmitterIndicator
      tag="LT_2961"
      totalLevel={50000}
      inflows={[FIC_2965a]}
      outflows={[FIC_2965b]}
      responseFactor={0.05}
      columnX={330}
      columnY={179}
      columnWidth={31}
      columnHeight={110}
      textX={175}
      textY={220}
      showFlow={true}
    />
   

    <LevelTransmitterIndicator
      tag="LT_2962"
      totalLevel={50000}
      inflows={[FIC_2965b]}
      outflows={[FIC_2964]}
      responseFactor={0.05}
      columnX={449}
      columnY={193}
      columnWidth={56}
      columnHeight={95}
      textX={535}
      textY={150}
      showFlow={true}
    />


    <LevelTransmitterIndicator
      tag="LT_2963"
      totalLevel={50000}
      inflows={[PDT_2961]}
      outflows={[FIC_2962]}
      responseFactor={0.05}
      columnX={284}
      columnY={428}
      columnWidth={73}
      columnHeight={95}
      textX={175}
      textY={420}
      showFlow={true}
    />

    <LevelTransmitterIndicator
      tag="LT_2964"
      totalLevel={100000}
      inflows={[FIC_2961]}
      outflows={[FIC_2963]}
      responseFactor={0.05}
      columnX={938}
      columnY={420}
      columnWidth={135}
      columnHeight={140}
      textX={849}
      textY={380}
      showFlow={true}
    />


    <Pump
      tag="P-2961"
      x={561}
      y={305}
      rpm={1800}
      bladeCount={pumpData?.["P-2961"]?.bladeCount || 3}
      size={pumpData?.["P-2961"]?.size || 30}
      onClick={openPumpPanel}
    />


    <Pump
      tag="P-2962"
      x={407}
      y={538}
      rpm={1800}
      bladeCount={pumpData?.["P-2962"]?.bladeCount || 3}
      size={pumpData?.["P-2962"]?.size || 30}
      onClick={openPumpPanel}
    />


    <Pump
      tag="P-2963"
      x={688}
      y={637}
      rpm={1800}
      bladeCount={pumpData?.["P-2963"]?.bladeCount || 3}
      size={pumpData?.["P-2963"]?.size || 30}
      onClick={openPumpPanel}
    />





    <div
                  className="pdt2961-input-group"
                  style={{
                    position: "absolute",
                    left: pdt2961Position.x,
                    top: pdt2961Position.y,
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    zIndex: 1000
                  }}
                >
                  <input
                    type="number"
                    className="pdt2961-input"
                    style={{
                      width: "30px",
                      padding: "0px",
                      background: "transparent",
                      color: "lightGrey",
                      border: "1px solid transparent",
                      borderRadius: "3px"
                    }}
                    value={PDT_2961}
                    onChange={(e) => setPDT_2961(Number(e.target.value) || 0)}
                  />
                </div>

    <div
                  className="sct2962-input-group"
                  style={{
                    position: "absolute",
                    left: sct2962Position.x,
                    top: sct2962Position.y,
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    zIndex: 1000
                  }}
                >
                  <input
                    type="number"
                    className="sct2962-input"
                    style={{
                      width: "30px",
                      padding: "0px",
                      background: "transparent",
                      color: "lightGrey",
                      border: "1px solid transparent",
                      borderRadius: "3px"
                    }}
                    value={SCT_2962}
                    onChange={(e) => setSCT_2962(Number(e.target.value) || 0)}
                  />
                </div>
    <div
                  className="tds2961-input-group"
                  style={{
                    position: "absolute",
                    left: tds2961Position.x,
                    top: tds2961Position.y,
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    zIndex: 1000
                  }}
                >
                  <input
                    type="number"
                    className="tds2961-input"
                    style={{
                      width: "30px",
                      padding: "0px",
                      background: "transparent",
                      color: "lightGrey",
                      border: "1px solid transparent",
                      borderRadius: "3px"
                    }}
                    value={TDS_2961}
                    onChange={(e) => setTDS_2961(Number(e.target.value) || 0)}
                  />
                </div>
          

          
          <Transmitter
          tag="PDT-2961"
          value={PDT_2961}
          x={185}
          y={425}
          unit="bar"
          max={5}
          HH={4}
          H={3}
          L={0.2}
          LL={0.05}
          c="transparent"
          description="FOULING FACTOR - SEAWATER STRAINER"
        />
          <Transmitter
          tag="SCT-2962"
          value={SCT_2962}
          x={377}
          y={398}
          unit="%"
          max={40}
          HH={35}
          H={30}
          L={20}
          LL={15}
          c="lime"
          description="SODIUM CHLORIDE CONCENTRATION TRANSMITTER"
        />
          <Transmitter
          tag="TDS-2961"
          value={TDS_2961}
          x={377}
          y={437}
          unit="ppb"
          max={100}
          HH={90}
          H={80}
          L={20}
          LL={15}
          c="lime"
          description="SALT CONCENTRATION TRANSMITTER"
        />
          <Transmitter
          tag="TT-2962"
          value={TT_2962}
          x={1117}
          y={147}
          unit="°C"
          max={50}
          HH={48}
          H={46}
          L={29}
          LL={23}
          c="lime"
          description="ELECTROLYTE COIL TEMPERATURE FOR ELECTROLIZED WATER GOING TO SODIUM HYPOCHLORITE TANK"
        />
         
          <Transmitter
          tag="TT-2961"
          value={TT_2961}
          x={1117}
          y={437}
          unit="°C"
          max={50}
          HH={48}
          H={46}
          L={29}
          LL={23}
          c="lime"
          description="SODIUM HYPOCHLORITE TANK TEMPERATURE"
        />
          <Transmitter
          tag="pH-2961"
          value={pH_2961}
          x={1119}
          y={538}
          unit="%"
          max={13}
          HH={12.5}
          H={12}
          L={7.5}
          LL={7}
          c="lime"
          description="SODIUM HYPOCHLORITE TANK pH"
        />
          <Transmitter
          tag="CLT-2961"
          value={CLT_2961}
          x={865}
          y={511}
          unit="%"
          max={13}
          HH={12.5}
          H={12}
          L={7.5}
          LL={7}
          c="lime"
          description="SODIUM HYPOCHLORITE TANK FREE CHLORINE TRANSMITTER"
        />




















    <div style={{ padding: 20, fontFamily: "Arial" }}>

      {/* ================= RECTANGLE ================= */}
      <div
        onMouseDown={handleMouseDown}
        onClick={handleToggle}
        style={{
          position: "absolute",
          left: position.x,
          top: position.y,
          width: "100px",
          height: "30px",
          backgroundColor: getColor(),
          border: "2px solid #333",
          borderRadius: "8px",
          cursor: isDragging ? "grabbing" : "grab",
          resize: "both",
          overflow: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          userSelect: "none",
          transition: "background-color 0.2s linear"
        }}
      >
        <div style={{ textAlign: "center" }}>
          <b>{isCoilOn ? "COIL ON 🔥" : "COIL OFF 🌡️"}</b>
        </div>
      </div>

           
    </div>




    </div>
  );
}

export default Na2HydroGen;